// Keep single-line references compact in move labels and line-number gutters.
export const lineRange = (start, end) => start === end ? `${start}` : `${start}–${end}`;
export const lineLabel = (start, end) => `${start === end ? 'line' : 'lines'} ${lineRange(start, end)}`;
